import React from 'react';
import SentimentSatisfiedAltIcon from '@mui/icons-material/SentimentSatisfiedAlt';
import SentimentNeutralIcon from '@mui/icons-material/SentimentNeutral';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';

const faceClass = [
  'flex h-full cursor-pointer select-none flex-col items-center rounded-2xl border border-slate-200',
  'bg-white px-2 py-4 text-sm text-slate-700 shadow-sm transition duration-200',
  'hover:scale-105 hover:border-slate-300 hover:shadow-md active:scale-95 sm:px-4 sm:text-[15px]',
].join(' ');

const pillClass = 'rounded-xl px-4 py-3 text-center text-[15px] shadow-sm';

const Sentiment = ({
  openHandler,
  experienceGetData,
}) => (
  <div>
    <div className="flex justify-center gap-3 sm:gap-4">
      <div className="min-w-0 flex-1 empty:hidden sm:max-w-[160px]" onClick={() => openHandler(1)}>
        {experienceGetData?.template?.sentiment_image_enable && (
          <div className={faceClass}>
            <SentimentSatisfiedAltIcon
              style={{            
                marginBottom: '5px',
                fontSize: '4rem',
                color: 'rgb(104,159,56)',
              }}
            />
            <div className="text-center">
              {experienceGetData?.template?.sentiment_happy_name}
            </div>
          </div>
        )}             
      </div>

      <div className="min-w-0 flex-1 empty:hidden sm:max-w-[160px]" onClick={() => openHandler(2)}>
        {experienceGetData?.template?.sentiment_netural_enable && (
        <div className="h-full">
          {experienceGetData?.template?.sentiment_image_enable && (
          <div className={faceClass}>
            <SentimentNeutralIcon
              style={{                    
                marginBottom: '5px',
                fontSize: '4rem',
                color: 'rgb(153,153,153)',
              }}
            />
            <div className="text-center">
              {experienceGetData?.template?.sentiment_neutral_name}
            </div>
          </div>
          )}
                    
        </div>
        )} 
           
      </div>

      <div className="min-w-0 flex-1 empty:hidden sm:max-w-[160px]" onClick={() => openHandler(3)}>
        {experienceGetData?.template?.sentiment_image_enable && (
          <div className={faceClass}>
            <SentimentVeryDissatisfiedIcon 
              style={{            
                marginBottom: '5px',
                fontSize: '4rem',
                color: '#D47878',
              }}
            />
            <div className="text-center">
              {experienceGetData?.template?.sentiment_sad_name}
            </div>
          </div>
        )}          
      </div>
    </div>

    {!experienceGetData?.template?.sentiment_image_enable && (
    <div className="flex flex-col gap-2.5">
      <div
        className={pillClass}
        style={{
          backgroundColor: 'rgb(104,159,56)', color: 'white',
        }}
      >
        {experienceGetData?.template?.sentiment_happy_name}
      </div>
      <div
        className={pillClass}
        style={{
          backgroundColor: 'rgb(153,153,153)', color: 'white',
        }}
      >
        {experienceGetData?.template?.sentiment_neutral_name}
      </div>
      <div
        className={pillClass}
        style={{
          backgroundColor: '#D47878', color: 'white',
        }}
      >
        {experienceGetData?.template?.sentiment_sad_name}
      </div>
    </div>
    )}
      
  </div>
);

export default Sentiment;
